import i18next from './i18n';

export const validatePassword = (input: string): string => {
  const lowercaseRegEx = /[a-z]/g;
  const uppercaseRegEx = /[A-Z]/g;
  const digitRegEx = /\d/g;
  if (input.length < 9) {
    return i18next.t('validators.passwordLength');
  } else if (!lowercaseRegEx.test(input)) {
    return i18next.t('validators.passwordLowercase');
  } else if (!uppercaseRegEx.test(input)) {
    return i18next.t('validators.passwordUppercase');
  } else if (!digitRegEx.test(input)) {
    return i18next.t('validators.passwordNumeric');
  }
  return '';
};

export const validatePasswordLength = (input: string) =>
  input.length >= 10 && input.length <= 30;
export const validatePasswordUppercase = (input: string) => /[A-Z]/.test(input);
export const validatePasswordLowercase = (input: string) => /[a-z]/.test(input);
export const validatePasswordNumber = (input: string) => /\d/.test(input);
export const validatePasswordSpecialCharacter = (input: string) =>
  /[^A-Za-z0-9]/.test(input);

export const validateStrongPassword = (input: string): boolean => {
  return (
    validatePasswordLength(input) &&
    validatePasswordUppercase(input) &&
    validatePasswordLowercase(input) &&
    validatePasswordNumber(input) &&
    validatePasswordSpecialCharacter(input)
  );
};
